module.exports = __webpack_public_path__ + "static/img/our-people-company-values-grid-2.933e1e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-company-values-grid-2.jpg
// module id = X5kE
// module chunks = 0